<div class="status-container" [style.color]="getVerificationStatusTextColor(verificationResult?.check_result)">
    {{ statusText }}
    <div class="icon">
        <mat-icon>{{ getIcon() }}</mat-icon>
    </div>
</div>